import styles from "./BenefitsModal.module.css";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, List, Modal, Row, Skeleton, Space } from "antd";
import InputText from "../../../../CommonComponents/InputControls/InputText";
import useNotification from "../../../../../hooks/useNotification";
import EnterpriseServices from "../../../../../services/EnterpriseServices";
import { TiDelete } from "react-icons/ti";

const BenefitsModal = ({ isOpen, onCancel, onSubmit, data }) => {
  const [loading, setLoading] = useState(true);
  const { showNotification } = useNotification();
  const [initialData, setInitialData] = useState({});
  const [value, setValue] = useState("");
  const [benefit, setBenefit] = useState("");

  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      setLoading(false);
      const initData = {
        companyValues: data?.companyValues || [],
        companyBenefits: data?.companyBenefits || [],
      };
      setInitialData(initData);
      // form.setFieldsValue(initData);
    }
  }, [isOpen]);

  const handleOk = () => {
    onCancel(false);
  };
  const handleCancel = () => {
    onCancel(false);
  };

  const onFinish = async (values) => {
    console.warn("values", initialData);
    try {
      setLoading(true);
      var payload = {
        _id: data._id,
       ...initialData,
      };
      console.log("payload payload", payload);
      const res = await EnterpriseServices.UpdateEnterprise(payload);
      if (res.statusCode === 1) {
        onSubmit();
        onCancel(false);
        showNotification("Company values updated Successfully");
        setLoading(false);
      } else {
        handleError(`${res.statusDesc}`);
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while updating banner", error);
        handleError(error.description);
      } else {
        handleError("Error: company values is not updated.");
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const handleChange = (key, value) => {
    console.log(initialData, key, value, {
      ...initialData,
      [key]: [...initialData[key], value],
    });
    form.setFieldsValue({ [key]: "" });
    setInitialData({ ...initialData, [key]: [...initialData[key], value] });
  };

  const removeItem = (key, index) => {
    const data = initialData;
    data[key].splice(index, 1);
    setInitialData({ ...data });
  };

  return (
    <>
      <Modal
        title="Company Values & Benefits"
        open={isOpen}
        footer={false}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          name="basic"
          form={form}
          layout="vertical"
          style={{ marginTop: 20 }}
          className={styles.form_wrap}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={initialData}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              Values
              <Space.Compact style={{ width: "100%" }}>
                <InputText
                  placeholder="Enter your first name"
                  value={value}
                  name="companyValues"
                  onChange={(_, e) => setValue(e)}
                  rules={[
                    {
                      required: false,
                      message: "First name is required !",
                      whitespace: false,
                    },
                  ]}
                />
                <Button
                  type="primary"
                  onClick={() => handleChange("companyValues", value)}
                >
                  Add
                </Button>
              </Space.Compact>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              Benefits
              <Space.Compact style={{ width: "100%" }}>
                <InputText
                  placeholder="Enter your first name"
                  value={benefit}
                  name="companyBenefits"
                  onChange={(_, e) => setBenefit(e)}
                  rules={[
                    {
                      required: false,
                      message: "First name is required !",
                      whitespace: false,
                    },
                  ]}
                />
                <Button
                  type="primary"
                  onClick={() => handleChange("companyBenefits", benefit)}
                >
                  Add
                </Button>
              </Space.Compact>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <List
                itemLayout="horizontal"
                loadMore={false}
                dataSource={initialData.companyValues}
                renderItem={(item, i) => (
                  <List.Item
                    actions={[
                      <a
                        key="list-loadmore-edit"
                        onClick={() => removeItem("companyValues", i)}
                      >
                        <TiDelete />
                      </a>,
                    ]}
                  >
                    <Skeleton
                      avatar
                      title={false}
                      loading={item.loading}
                      active
                    >
                      <div>{item}</div>
                    </Skeleton>
                  </List.Item>
                )}
              />
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <List
                itemLayout="horizontal"
                loadMore={false}
                dataSource={initialData.companyBenefits}
                renderItem={(item, i) => (
                  <List.Item
                    actions={[
                      <a
                        key="list-loadmore-edit"
                        onClick={() => removeItem("companyBenefits", i)}
                      >
                        <TiDelete />
                      </a>,
                    ]}
                  >
                    <Skeleton
                      avatar
                      title={false}
                      loading={item.loading}
                      active
                    >
                      <div>{item}</div>
                    </Skeleton>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
          <div className={styles.footer}>
            <Form.Item>
              <Button
                className={styles.submit_btn}
                type="primary"
                // htmlType="submit"
                onClick={onFinish}
                loading={loading}
              >
                Submit
              </Button>
            </Form.Item>
            <Button
              className={styles.cancel_btn}
              type="secondary"
              loading={false}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default BenefitsModal;
